import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button/Button";
import {withRouter} from "react-router";
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';


String.prototype.trunc =
  function (n, useWordBoundary) {
    if (this.length <= n) {
      return this;
    }
    var subString = this.substr(0, n - 1);
    return (useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(' '))
      : subString) + "...";
  };


class UserRequestCardNotOpen extends React.Component {

  state = {
    notes: false
  }

  constructor() {
    super();
    this.goTo = this.goTo.bind(this);
  }

  goTo(location) {
    this.props.history.push(location);
  }

  render() {
    const { request} = this.props;

    return (
      <Paper
        className={"exclusive-card help-card"}>

        <Grid container>

          <Grid item md={11}>
            <Button size="small" color="primary"
                      onClick={() => this.goTo(`/user_requests/${request.id}`)}>Novo Pedido</Button>
          </Grid>

          <Grid item md={1} className="to-open">
            <Grid container>
              <Button size="small" color="primary"
                      onClick={() => this.goTo(`/user_requests/${request.id}`)}>Open</Button>
            </Grid>
          </Grid>
          
        </Grid>
      </Paper>

      

    );
  }
}

const styles = theme => ({
  payment_ok: {
    color:"green"
  },
  payment_nok: {
    color: "red"
  },
  payment_waiting: {
    color: "goldenrod"
  },
});

UserRequestCardNotOpen.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(withRouter(UserRequestCardNotOpen));
